import React from "react";
import Flagship from "../../core/flagship";
import {
  Table,
  Button,
  Header,
  Segment,
  Icon,
  Grid,
  Label,
  Popup
} from "semantic-ui-react";
import { empty, unformatTime } from "../../utils/helpers";
import * as actions from "../../actions/appActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ClientField from "./ClientField";
import Field from "./Field";
import TimeEntryEditModal from "../modals/TimeEntryEditModal";
import moment from "moment-business-days";
import { browserHistory, Link } from "react-router";
import ReactDOM from "react-dom";

class TimeTrackingEntry extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      addingTime: props.addingTime,
      timesheetsForDay: [],
      hoursForMonth: [],
      notes: "",
      editingEntry: false,
      client: props.fromTimer ? props.timerClient : null,
      task: props.fromTimer ? props.timerTask : null,
      hoursTracked: props.fromTimer
        ? (props.timeRecorded / 60 / 60).toFixed(2)
        : 0
    };

    if (this.props.fromPrevious) {
      let { client, task, record_name } = this.props.usingPreviousTimesheet;
      this.state.client = { id: client, name: record_name };
      this.state.task = task;
    }

    this.getTimesheetsForDate = this.getTimesheetsForDate.bind(this);
    this.updateHoursTracked = this.updateHoursTracked.bind(this);
    this.formatHoursTracked = this.formatHoursTracked.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.updateNotes = this.updateNotes.bind(this);
    this.onChangeTask = this.onChangeTask.bind(this);
    this.editEntry = this.editEntry.bind(this);
    this.usePreviousTimesheet = this.usePreviousTimesheet.bind(this);
    this.updateEntry = this.updateEntry.bind(this);
    this.deleteEntry = this.deleteEntry.bind(this);
    this.renderTimeEntry = this.renderTimeEntry.bind(this);
    this.onChangeClient = this.onChangeClient.bind(this);
    this.addTime = this.addTime.bind(this);
    this.useTimerData = this.useTimerData.bind(this);
    this.setClientRef = this.setClientRef.bind(this);
    this.focusClient = this.focusClient.bind(this);
  }

  componentDidMount() {
    this.getTimesheetsForDate();
    if (this.props.fromTimer === true) {
      this.props.actions.stopTrackTime();
      this.props.actions.toggleTimeTracker(false);
      Flagship.post("timesheets/timer/stop", {
        user: this.props.userId,
        banked: this.props.timeRecorded
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedDate !== this.props.selectedDate) {
      this.getTimesheetsForDate();
    }

    if (prevProps.fromTimer !== true && this.props.fromTimer === true) {
      this.props.actions.stopTrackTime();
      this.props.actions.toggleTimeTracker(false);
      Flagship.post("timesheets/timer/stop", {
        user: this.props.userId,
        banked: this.props.timeRecorded
      });
      if (prevProps.timerRunning)
        Flagship.notify("Timer stopped for entry.", "info");
    }

    if (prevProps.fromPrevious !== true && this.props.fromPrevious === true) {
      let { client, task, record_name } = this.props.usingPreviousTimesheet;
      this.setState({
        client: { id: client, name: record_name },
        task: task,
        addingTime: this.props.addingTime
      });
    }

    if (prevProps.addingTime !== this.props.addingTime) {
      this.setState({
        addingTime: this.props.addingTime
      });
    }
  }

  useTimerData() {
    let self = this;
    this.setState(
      {
        client: this.props.timerClient,
        task: this.props.timerTask,
        hoursTracked: (this.props.timeRecorded / 60 / 60).toFixed(2)
      },
      function() {
        self.props.actions.stopTrackTime();
        self.props.actions.toggleTimeTracker(false);
        browserHistory.push(
          "/time/date/" +
            moment(self.props.selectedDate, "MM/DD/YY").format("MM-DD-YYYY") +
            "/add/timer"
        );
      }
    );
  }

  getTimesheetsForDate() {
    let self = this;
    Flagship.get(
      "timesheets/user/" +
        this.props.userId +
        "/" +
        moment(self.props.selectedDate, "MM/DD/YY").format("YYYY-MM-DD"),
      {},
      function(response) {
        if (response.data.success === true) {
          self.setState({
            timesheetsForDay: response.data.results
          });
        } else {
          Flagship.error(
            "Failed to retrieve timesheet entries.",
            self.props.timerClient,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Failed to retrieve timesheet entries: " + err,
          self.props.timerClient,
          self.props.userId
        );
      }
    );
  }

  addTime(value = true) {
    let self = this;
    this.setState(
      {
        addingTime: value
      },
      function() {
        Flagship.redirect(
          "/time/date/" +
            moment(self.props.selectedDate, "MM/DD/YY").format("MM-DD-YYYY") +
            (self.state.addingTime ? "/add" : "")
        );
      }
    );
  }

  editEntry(entry) {
    this.setState({
      editingEntry: entry
    });
  }

  usePreviousTimesheet(entry) {
    this.props.actions.usePreviousTimesheet(entry);
  }

  updateHoursTracked(e) {
    let hours = e.target.value;

    this.setState({
      hoursTracked: hours
    });
  }

  formatHoursTracked() {
    let hours = this.state.hoursTracked;

    let timeFormat = /^([0-9]{1,2})?\:([0-9]{2})$/;
    if (timeFormat.test(hours)) {
      hours = unformatTime(hours);
    }

    hours = parseFloat(hours);
    if (isNaN(hours)) {
      hours = 0.0;
    }

    this.setState({
      hoursTracked: hours.toFixed(2)
    });
  }

  updateNotes(e, data) {
    this.setState({
      notes: data
    });
  }

  onChangeClient(e, data) {
    this.setState({
      client: data.value
    });
  }

  onChangeTask(e, task) {
    this.setState({
      task
    });
  }

  deleteEntry(entry) {
    let self = this;

    Flagship.post(
      "timesheets/delete/" + entry.id,
      {},
      function(response) {
        if (response.data.success === true) {
          self.getTimesheetsForDate();
          self.props.onUpdate();
          Flagship.notify("Time entry deleted.", "info");
          self.setState({
            editingEntry: false
          });
        } else {
          Flagship.error(
            "Failed to delete time entry.",
            entry.id,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Failed to delete time entry: " + err,
          entry.id,
          self.props.userId
        );
      }
    );
  }

  updateEntry(entry) {
    let self = this;
    Flagship.post(
      "timesheets/update/" + entry.id,
      {
        client: entry.client.id,
        user: this.props.userId,
        hours: entry.hours,
        date: moment(entry.date).format("YYYY-MM-DD"),
        task: entry.task,
        notes: entry.notes
      },
      function(response) {
        if (response.data.success === true) {
          self.getTimesheetsForDate();
          self.props.onUpdate();
          Flagship.notify("Time entry updated.", "success");
          self.setState({
            editingEntry: false
          });
        } else {
          Flagship.error(
            "Failed to update time entry.",
            entry.client.id,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Failed to update time entry: " + err,
          entry.client.id,
          self.props.userId
        );
      }
    );
  }

  onSubmit(keepAdding = false) {
    let self = this;

    Flagship.post(
      "timesheets/submit",
      {
        client: this.state.client.id,
        user: this.props.userId,
        hours: this.state.hoursTracked,
        date: this.props.selectedDate,
        task: this.state.task,
        notes: this.state.notes
      },
      function(response) {
        if (response.data.success === true) {
          if (self.props.fromTimer === true) {
            Flagship.post("timesheets/timer/clear-time-only", {
              user: self.props.userId
            });
            self.props.actions.clearTime();
          }
          self.getTimesheetsForDate();
          Flagship.notify("Time entry added.", "success");
          self.setState(
            {
              addingTime: keepAdding,
              hoursTracked: 0,
              task: null,
              client: null,
              notes: ""
            },
            function() {
              if (keepAdding === true) {
                self.focusClient();
              }
              self.props.onUpdate();
            }
          );
        } else {
          Flagship.error(
            "Failed to submit time entry.",
            self.props.timerClient,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Failed to submit time entry: " + err,
          self.props.timerClient,
          self.props.userId
        );
      }
    );
  }

  renderTimeEntry(entry, i) {
    return (
      <Table.Row key={i}>
        <Table.Cell>{entry.hours}</Table.Cell>
        <Table.Cell>{entry.record_name}</Table.Cell>
        <Table.Cell>
          <Label>
            {entry.instance !== "Standard" ? entry.instance : entry.market}
          </Label>
        </Table.Cell>
        <Table.Cell>{entry.task === null ? "Unknown" : entry.task}</Table.Cell>
        <Table.Cell style={{ width: "210px" }}>
          <Button
            size="small"
            onClick={() => {
              this.editEntry(entry);
            }}
          >
            Edit
          </Button>
          <Button
            size="small"
            style={{
              width: "100px",
              color: "#ffffff",
              display: "inline-block",
              padding: ".78571429em 1.0em .78571429em"
            }}
            color="black"
            as={Link}
            onClick={() => this.usePreviousTimesheet(entry)}
            to={"/time/date/" + moment().format("MM-DD-YYYY") + "/add/previous"}
          >
            Use again
          </Button>
        </Table.Cell>
      </Table.Row>
    );
  }

  setClientRef(ref) {
    this.clientRef = ref;
  }

  focusClient() {
    // Don't want to use findDOMNode but don't currently have a choice :(
    const dropdownParent = ReactDOM.findDOMNode(this.clientRef);
    const input = dropdownParent.querySelector(".search");
    input.focus();
  }

  render() {
    let self = this;
    let totalHoursForDay = 0;

    return (
      <div className="fade-in time-tracking-entry">
        <Segment.Group>
          <Segment>
            <Header>
              My Time for {this.props.selectedDate}
              {this.state.addingTime ? (
                <Button
                  floated="right"
                  style={{ marginTop: "-6px" }}
                  onClick={() => {
                    this.addTime(false);
                  }}
                >
                  <Icon name="cancel" />
                  Cancel
                </Button>
              ) : (
                <Button
                  floated="right"
                  style={{ marginTop: "-6px" }}
                  onClick={this.addTime}
                  color="teal"
                >
                  <Icon name="clock" />
                  Add Time...
                </Button>
              )}
            </Header>
          </Segment>
          {this.state.addingTime ? (
            <Segment>
              <div className="slide-down add-time-form">
                <div className="fade-in">
                  <Grid>
                    <Grid.Row>
                      <Grid.Column
                        mobile={16}
                        tablet={16}
                        computer={16}
                        largeScreen={16}
                        widescreen={16}
                        style={{ padding: "0 1em" }}
                      >
                        <Header className="new-time-entry-header">
                          New Entry {this.props.fromTimer ? "From Timer" : null}
                          {this.props.timeRecorded &&
                          this.props.fromTimer !== true ? (
                            <Button
                              className="pulsing-button-pulsing"
                              onClick={this.useTimerData}
                            >
                              <Icon name="clock" />
                              Use Timer Data
                            </Button>
                          ) : null}
                        </Header>
                        <div className="flagship-single-field">
                          <div className="flagship-input">
                            <div>
                              <Label
                                className="single-field-label"
                                size="large"
                              >
                                Client
                              </Label>

                              <ClientField
                                value={this.state.client}
                                anyInstance={true}
                                onChange={(e, data) =>
                                  self.onChangeClient(e, data)
                                }
                                placeholder="Begin typing to select a client..."
                                disableAddNew={true}
                                forceFocus={!this.props.fromPrevious}
                                setRef={this.setClientRef}
                              />
                            </div>
                          </div>
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Column
                      mobile={16}
                      tablet={16}
                      computer={16}
                      largeScreen={8}
                      widescreen={8}
                      style={{ padding: "0 1em" }}
                    >
                      <Field
                        type="text"
                        label="Hours"
                        validation="decimalOrTime"
                        filterInput="decimalOrTime"
                        value={
                          this.state.hoursTracked > 0
                            ? this.state.hoursTracked
                            : ""
                        }
                        onBlur={this.formatHoursTracked}
                        onChange={this.updateHoursTracked}
                        forceFocus={this.props.fromPrevious}
                      />
                    </Grid.Column>

                    <Grid.Column
                      mobile={16}
                      tablet={16}
                      computer={16}
                      largeScreen={16}
                      widescreen={16}
                      style={{ padding: "0 1em" }}
                    >
                      <Field
                        type="select"
                        label="Category"
                        onChange={(e, data) => self.onChangeTask(e, data)}
                        value={this.state.task}
                        options={Flagship.config.timeTrackerTasks}
                      />
                      <small style={{ color: "#666" }}>
                        Select the service or activity that this time falls
                        under.
                      </small>
                    </Grid.Column>
                  </Grid>

                  <Grid.Column
                    mobile={16}
                    tablet={16}
                    computer={16}
                    largeScreen={16}
                    widescreen={16}
                    style={{ padding: "1em 0" }}
                  >
                    <Field
                      type="textarea"
                      label="Notes (Optional)"
                      validation="none"
                      onChange={this.updateNotes}
                    />
                  </Grid.Column>
                  {!empty(this.state.hoursTracked) &&
                  this.state.hoursTracked !== ":" &&
                  this.state.hoursTracked !== "." &&
                  this.state.hoursTracked !== "0" &&
                  this.state.hoursTracked !== "0.00" &&
                  this.state.hoursTracked !== "0." &&
                  this.state.client !== false &&
                  this.state.client !== null &&
                  this.state.task !== false &&
                  this.state.task !== null &&
                  typeof this.state.client !== "undefined" ? (
                    <div>
                      <Button
                        color="teal"
                        onClick={() => {
                          this.onSubmit(false);
                        }}
                        className={
                          this.props.fromTimer ? "pulsing-button-pulsing" : null
                        }
                      >
                        Submit Time Entry
                      </Button>
                      {this.props.fromTimer ? (
                        <small
                          className="gray-text"
                          style={{ marginLeft: "1em" }}
                        >
                          Submitting this entry will also reset your timer.
                        </small>
                      ) : (
                        <Button
                          secondary
                          onClick={() => {
                            this.onSubmit(true);
                          }}
                        >
                          Submit & Add Another
                        </Button>
                      )}
                    </div>
                  ) : (
                    <div>
                      {this.state.hoursTracked <= 0 ? (
                        <em>Add some hours before submitting. </em>
                      ) : null}
                      {this.state.client === null ||
                      typeof this.state.client === "undefined" ? (
                        <em>Don't forget to select a client. </em>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
            </Segment>
          ) : null}
          <Segment>
            <Table celled striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="5">Time Entries</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {this.state.timesheetsForDay.length > 0 ? (
                  this.state.timesheetsForDay.map(function(entry, i) {
                    let rendered = self.renderTimeEntry(entry, i);
                    totalHoursForDay += parseFloat(entry.hours);
                    if (empty(entry.notes)) {
                      return rendered;
                    } else {
                      return (
                        <Popup
                          key={i}
                          trigger={rendered}
                          content={entry.notes}
                          position="bottom left"
                          inverted
                          className="time-entry-notes-popup"
                        />
                      );
                    }
                  })
                ) : (
                  <Table.Row>
                    <Table.Cell collapsing>
                      No time entries for this day.
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
              <Table.Footer fullWidth>
                <Table.Row>
                  <Table.HeaderCell>
                    <strong>{totalHoursForDay.toFixed(2)}</strong>
                  </Table.HeaderCell>
                  <Table.HeaderCell colSpan="4">
                    Total hours recorded on {this.props.selectedDate}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>

            <TimeEntryEditModal
              open={this.state.editingEntry !== false}
              cancelEdit={() => {
                this.editEntry(false);
              }}
              {...this.state.editingEntry}
              onUpdateEntry={this.updateEntry}
              onDeleteEntry={this.deleteEntry}
            />
          </Segment>
        </Segment.Group>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    firstName: state.main.userFirstName,
    userRole: state.main.userRole,
    userId: state.main.userId,
    timerRunning: state.time.timerRunning,
    timeRecorded: state.time.timeRecorded,
    timeRecordedFormatted: state.time.timeRecordedFormatted,
    timerClient: state.time.timerClient,
    timerTask: state.time.timerTask,
    usingPreviousTimesheet: state.time.usingPreviousTimesheet
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TimeTrackingEntry);



// WEBPACK FOOTER //
// ./src/components/misc/TimeTrackingEntry.js